import React from 'react';
import Reflux from 'reflux';
import moment from 'moment';
import DatePicker from 'react-date-picker';
import 'moment/locale/hu';
import 'react-datepicker/dist/react-datepicker.css';
import i18 from '../../../i18';
import {supplierApi} from '../../../api';
import Field from '../../common/Field';
import Validator from '../../common/Validator';
import api from "../../../source/api";

const REGISTRATION_ROWS = [
    {
        label: 'KÉSZPÉNZES SZÁMLÁK RÖGZÍTÉSE',
        hufField: 'registration_number_cash_huf',
        foreignField: 'registration_number_cash_foreign',
    },
    {
        label: 'ÁTUTALÁSOS SZÁMLÁK RÖGZÍTÉSE',
        hufField: 'registration_number_transfer_huf',
        foreignField: 'registration_number_transfer_foreign',
    },
    {
        label: 'BANKKÁRTYÁS SZÁMLÁK RÖGZÍTÉSE',
        hufField: 'registration_number_card_huf',
        foreignField: 'registration_number_card_foreign',
    },
    {
        label: 'UTALVÁNYOS SZÁMLÁK RÖGZÍTÉSE',
        hufField: 'registration_number_voucher_huf',
        foreignField: 'registration_number_voucher_foreign',
    },
    {
        label: 'EGYÉB SZÁMLÁK RÖGZÍTÉSE',
        hufField: 'registration_number_other_huf',
        foreignField: 'registration_number_other_foreign',
    },
];

class Upload extends Reflux.Component {

    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            fields: this.createFields(props.config),
            startDate: this.createDate(
                props.config.start_date,
            ),
            endDate: this.createDate(
                props.config.end_date,
            ),
            dateError: '',
        };
    }

    createDate = (value) => {
        const date = value
            ? new Date(value)
            : new Date();

        return Number.isNaN(date.getTime())
            ? new Date()
            : date;
    };

    createField = (
        value,
        required = true,
    ) => {
        return {
            value: value !== null
            && typeof value !== 'undefined'
                ? value
                : '',
            error: '',
            role: {
                required,
            },
        };
    };

    createFields = (config) => {
        return {
            payment_method: this.createField(
                config.payment_method,
            ),
            date_type: this.createField(
                config.date_type,
            ),
            registration_number_transfer_huf:
                this.createField(
                    config.registration_number_transfer_huf,
                ),
            registration_number_transfer_foreign:
                this.createField(
                    config.registration_number_transfer_foreign,
                ),
            registration_number_cash_huf:
                this.createField(
                    config.registration_number_cash_huf,
                ),
            registration_number_cash_foreign:
                this.createField(
                    config.registration_number_cash_foreign,
                ),
            registration_number_card_huf:
                this.createField(
                    config.registration_number_card_huf,
                ),
            registration_number_card_foreign:
                this.createField(
                    config.registration_number_card_foreign,
                ),
            registration_number_voucher_huf:
                this.createField(
                    config.registration_number_voucher_huf,
                ),
            registration_number_voucher_foreign:
                this.createField(
                    config.registration_number_voucher_foreign,
                ),
            registration_number_other_huf:
                this.createField(
                    config.registration_number_other_huf,
                ),
            registration_number_other_foreign:
                this.createField(
                    config.registration_number_other_foreign,
                ),
            export_date_type: this.createField(
                config.export_date_type,
            ),
            job_number: this.createField(
                config.job_number,
                false,
            ),
            inputXml: this.createField(
                '',
                true,
            ),
            partners: this.createField(
                '',
                false,
            ),
        };
    };

    getCompanyId = () => {
        const {config} = this.props;

        return config
        && config.company_id
            ? config.company_id
            : null;
    };

    getErrorMessage = (
        error,
        fallbackMessage,
    ) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        if (
            error
            && error.message
        ) {
            return error.message;
        }

        return fallbackMessage;
    };

    getFieldValue = (name) => {
        const field = this.state.fields[name];

        return field
            ? field.value
            : '';
    };

    setValue = (
        name,
        value,
        error = '',
    ) => {
        this.setState((previousState) => ({
            fields: {
                ...previousState.fields,
                [name]: {
                    ...previousState.fields[name],
                    value,
                    error,
                },
            },
        }));
    };

    onSelectChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setValue(
            name,
            value,
            '',
        );
    };

    handleStartDateChange = (date) => {
        this.setState({
            startDate: date,
            dateError: '',
        });
    };

    handleEndDateChange = (date) => {
        this.setState({
            endDate: date,
            dateError: '',
        });
    };

    validateDates = () => {
        const {
            startDate,
            endDate,
        } = this.state;

        let dateError = '';

        if (
            !startDate
            || !endDate
        ) {
            dateError =
                'A kezdő és a záró dátum megadása kötelező.';
        } else if (
            moment(startDate).isAfter(
                moment(endDate),
                'day',
            )
        ) {
            dateError =
                'A kezdő dátum nem lehet későbbi a záró dátumnál.';
        }

        this.setState({
            dateError,
        });

        return !dateError;
    };

    validate = () => {
        const fields = {
            ...this.state.fields,
            inputXml: {
                ...this.state.fields.inputXml,
                role: {
                    ...this.state.fields.inputXml.role,
                    required: true,
                },
            },
        };

        const validatorResponse =
            Validator.validate(fields);

        if (validatorResponse.error) {
            this.setState({
                fields: validatorResponse.fields,
            });

            return false;
        }

        return this.validateDates();
    };

    getSelectedFile = (elementId) => {
        const element =
            document.getElementById(elementId);

        if (
            !element
            || !element.files
            || element.files.length === 0
        ) {
            return null;
        }

        return element.files[0];
    };

    appendField = (
        formData,
        name,
    ) => {
        formData.append(
            name,
            this.getFieldValue(name),
        );
    };

    buildFormData = () => {
        const formData = new FormData();

        this.appendField(
            formData,
            'payment_method',
        );

        formData.append(
            'start_date',
            moment(this.state.startDate)
                .format('YYYY-MM-DD'),
        );

        formData.append(
            'end_date',
            moment(this.state.endDate)
                .format('YYYY-MM-DD'),
        );

        REGISTRATION_ROWS.forEach((row) => {
            this.appendField(
                formData,
                row.hufField,
            );

            this.appendField(
                formData,
                row.foreignField,
            );
        });


        const inputXml =
            this.getSelectedFile('inputXml');

        const partners =
            this.getSelectedFile('partners');

        if (inputXml) {
            formData.append(
                'inputFile',
                inputXml,
            );
        }

        if (partners) {
            formData.append(
                'partners',
                partners,
            );
        }

        return formData;
    };

    buildExportFormData = () => {
        const formData = new FormData();

        this.appendField(
            formData,
            'payment_method',
        );

        this.appendField(
            formData,
            'date_type',
        );

        formData.append(
            'start_date',
            moment(this.state.startDate)
                .format('YYYY-MM-DD'),
        );

        formData.append(
            'end_date',
            moment(this.state.endDate)
                .format('YYYY-MM-DD'),
        );

        const inputXml = this.getSelectedFile('inputXml');

        if (inputXml) {
            formData.append(
                'inputFile',
                inputXml,
            );
        }

        return formData;
    };

    updateFromUploadResponse = (responseData) => {
        if (
            responseData.outOfRange
            && responseData.outOfRange > 0
        ) {
            this.props.notifyError(
                `${responseData.outOfRange} számla `
                + 'kívül esik a dátumintervallumon!',
            );
        }

        this.props.updateConfig(
            responseData.config,
        );

        this.props.updateInvoices(
            responseData.invoices || [],
            this.props.supplierRules || [],
        );

        this.props.updatePartners(
            responseData.partners || [],
        );

        this.props.nextStep();
    };

    nextStep = async () => {
        if (this.state.processing) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        const companyId = this.getCompanyId();

        if (!companyId) {
            this.props.notifyError(
                'A cégazonosító nem található.',
            );

            return;
        }

        this.setState({
            processing: true,
        });

        try {
            const responseData = await supplierApi.upload(
                companyId,
                this.buildFormData(),
            );

            this.setState({
                processing: false,
            }, () => {
                this.updateFromUploadResponse(
                    responseData,
                );
            });
        } catch (error) {
            this.setState({
                processing: false,
            });

            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'Hiba történt a feldolgozás során.',
                ),
            );
        }
    };

    exportInvoices = async () => {
        if (this.state.processing) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        const companyId = this.getCompanyId();

        this.setState({
            processing: true,
        });

        try {
            const responseData = await supplierApi.generateExcel(
                companyId,
                this.buildExportFormData(),
            );

            if (
                !responseData
                || !responseData.name
            ) {
                throw new Error(
                    'A generált fájl neve hiányzik.',
                );
            }

            const url = supplierApi.downloadUrl(companyId);

            api.downloadFile(
                url,
                responseData.name,
            );
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                    'Hiba történt az Excel-export készítése során.',
                ),
            );
        } finally {
            this.setState({
                processing: false,
            });
        }
    };

    renderRegistrationField = (name) => {
        return (
            <Field
                type="text"
                id={name}
                name={name}
                label=""
                classLabel="control-label"
                classInput="bordered-input"
                setValue={this.setValue}
                state={this.state}
                style={{
                    width: '100%',
                }}
            />
        );
    };

    renderRegistrationRow = (row) => {
        return (
            <tr key={row.hufField}>
                <td>
                    {row.label}
                </td>

                <td className="text-center">
                    {this.renderRegistrationField(
                        row.hufField,
                    )}
                </td>

                <td className="text-center">
                    {this.renderRegistrationField(
                        row.foreignField,
                    )}
                </td>
            </tr>
        );
    };

    renderFilters = () => {
        return (
            <div className="row">
                <div className="col-3">
                    <select
                        value={
                            this.getFieldValue(
                                'payment_method',
                            )
                        }
                        name="payment_method"
                        onChange={this.onSelectChange}
                        className="minimal-100 form-control"
                        disabled={this.state.processing}
                    >
                        <option value="ALL">
                            Minden fizetési mód
                        </option>
                        <option value="TRANSFER">
                            Utalás
                        </option>
                        <option value="CASH">
                            Készpénz
                        </option>
                        <option value="CARD">
                            Kártya
                        </option>
                        <option value="VOUCHER">
                            Utalvány
                        </option>
                        <option value="OTHER">
                            Egyéb
                        </option>
                    </select>
                </div>

                <div className="col-3">

                </div>

                <div className="col-3">
                    <DatePicker
                        className="date-picker"
                        value={this.state.startDate}
                        onChange={
                            this.handleStartDateChange
                        }
                        required
                        showLeadingZeros
                        disabled={this.state.processing}
                    />
                </div>

                <div className="col-3">
                    <DatePicker
                        className="date-picker"
                        value={this.state.endDate}
                        onChange={
                            this.handleEndDateChange
                        }
                        required
                        showLeadingZeros
                        disabled={this.state.processing}
                    />
                </div>
            </div>
        );
    };

    renderDateError = () => {
        if (!this.state.dateError) {
            return null;
        }

        return (
            <p className="help-block help-block-error">
                <span className="error">
                    <i className="fa fa-warning"/>
                    {' '}
                    {this.state.dateError}
                </span>
            </p>
        );
    };

    renderRegistrationTable = () => {
        return (
            <table className="table table-striped table-aibook-bordered">
                <thead>
                <tr>
                    <th style={{width: '50%'}}>
                        Fizetés típusa
                    </th>

                    <th style={{width: '25%'}}>
                        Forintos
                    </th>

                    <th style={{width: '25%'}}>
                        Devizás
                    </th>
                </tr>
                </thead>

                <tbody>
                {REGISTRATION_ROWS.map(
                    this.renderRegistrationRow,
                )}

                </tbody>
            </table>
        );
    };

    renderFileInputs = () => {
        return (
            <React.Fragment>
                <div className="row mb-2">
                    <label
                        htmlFor="inputXml"
                        className="col-md-3 text-right"
                    >
                        Travel XML file
                    </label>

                    <Field
                        type="file"
                        id="inputXml"
                        name="inputXml"
                        fileUploadEndpoint=""
                        classInput="file-input"
                        setValue={this.setValue}
                        state={this.state}
                        style={{
                            width: '350px',
                            margin: 'auto',
                        }}
                    />
                </div>

                <div className="row">
                    <label
                        htmlFor="partners"
                        className="col-md-3 text-right"
                    >
                        Partnerek Excel
                    </label>

                    <Field
                        type="file"
                        id="partners"
                        name="partners"
                        fileUploadEndpoint=""
                        classInput="file-input"
                        setValue={this.setValue}
                        state={this.state}
                        style={{
                            width: '350px',
                            margin: 'auto',
                        }}
                    />
                </div>
            </React.Fragment>
        );
    };

    renderActions = () => {
        const {
            processing,
        } = this.state;

        return (
            <div
                className="next-step-btn-container text-center mt-4"
                style={{
                    width: '100%',
                }}
            >
                <button
                    type="button"
                    onClick={() => this.exportInvoices()}
                    className="next-step mr-2"
                    disabled={processing}
                >
                    {processing
                        ? i18.BUTTONS._processing
                        : 'Számlák Excel exportálása'
                    }
                </button>

                <button
                    type="button"
                    onClick={() => this.nextStep()}
                    className="next-step"
                    disabled={processing}
                >
                    {processing
                        ? i18.BUTTONS._processing
                        : i18.BUTTONS
                            ._goToAccountAssignment
                    }
                </button>
            </div>
        );
    };

    render() {
        return (
            <div className="supplier-upload-container">
                {this.renderFilters()}
                {this.renderDateError()}
                {this.renderRegistrationTable()}
                {this.renderFileInputs()}
                {this.renderActions()}
            </div>
        );
    }
}

export default Upload;



// WEBPACK FOOTER //
// ./src/components/supplier/steps/Upload.js